// src/constants/socialLinks.js
export const skypeUrl = 'https://join.skype.com/invite/AdDbThJOeejF';
export const facebookUrl = 'https://www.facebook.com/share/vC5S5JbubCZ47WRx/?mibextid=LQQJ4d';
export const instagramUrl = 'https://www.instagram.com/fastadvisory?igsh=dThhczEyODR2N29o';
export const telegramUrl = 'https://t.me/+4407385054407';
export const whatsappUrl = 'https://wa.me/+4407385054407';
export const linkedin = 'https://www.linkedin.com/haniehniazi?_l=en_US';
export const email = 'mailto:info@offshoreadvisory.pro';
